import Document from '@/generated/classes/Document';
import { DateFormat } from "@/framework/base/helpers/DateFormat";
import { PictoTypes } from "@/generated/classes/Module";
import { typePicto } from "@/framework/base/helpers/Picto";
import { DocumentTypeTitles, DocumentTypeDateTypes } from '@/generated/classes/DocumentType';
import { storeDocumentType } from '@/generated/stores';
import UserProfile from "@/framework/base/classes/UserProfile";

export default class DocumentExtend  extends Document {
  constructor() {
    super();
  }

  private static documentInfo (document: Document, info: DocumentTypeTitles, infoSalarie: DocumentTypeTitles, defaut: DocumentTypeTitles): string {
    let mode = defaut;
    if (infoSalarie != DocumentTypeTitles.NONE && UserProfile.isSalarie) {
      mode = infoSalarie;
    } else if (info != DocumentTypeTitles.NONE) {
      mode = info;
    }
    let res = "";
    if (mode == DocumentTypeTitles.ETABLISSEMENT) {
      res = document.etablissementId.toString();
    } else if (mode == DocumentTypeTitles.INFO) {
      res = document.info;
    } else if (mode == DocumentTypeTitles.SIGNATAIRE) {
      res = document.signataireId.toString();
    } else if (mode == DocumentTypeTitles.SALARIE) {
      res = document.salarieId.toString();
    }
    return res;
  }
  public static getTitle (document: Document): string {
    const type = storeDocumentType.getDocumentType(document.typeId);
    return DocumentExtend.documentInfo(document, type.title, type.titleSalarie, DocumentTypeTitles.REFERENCE);
 
  }

  public static getSubtitle (document: Document): string {
    const type = storeDocumentType.getDocumentType(document.typeId);
    return DocumentExtend.documentInfo(document, type.subtitle, type.subtitleSalarie, DocumentTypeTitles.INFO);
  }

  public static getType (document: Document): string {
    const type = storeDocumentType.getDocumentType(document.typeId);
    return type.label;
  }

  public static getPeriod (document: Document): string {
    let res = '';
    if (document.typeId > 0) {
      const type = storeDocumentType.getDocumentType(document.typeId);
      if (type.dateType == DocumentTypeDateTypes.ANNUEL) {
        res = DateFormat.getAnnuelLabel(document.dateDebut);
      } else if (type.dateType == DocumentTypeDateTypes.TRIMESTRIEL) {
        res = DateFormat.getTrimestrielLabel(document.dateDebut);
      } else if (type.dateType == DocumentTypeDateTypes.MENSUEL) {
        res = DateFormat.getMensuelLabel(document.dateDebut);
      } else if (type.dateType == DocumentTypeDateTypes.PERIODE) {
        res = DateFormat.getDebutFinLabel(document.dateDebut, document.dateFin);
      } else {
        res = DateFormat.getDateLabel(document.dateDebut);
      }
    }
    return res;
  }

  
  public static getData (document: Document): string[] {
    const res: string[] = [];
    res.push(DocumentExtend.getTitle(document));
    res.push(DocumentExtend.getSubtitle(document));
    res.push(DocumentExtend.getPeriod(document));
    res.push("100");
    return res;
  }

  public static getPicto (document: Document): string {
    const type = storeDocumentType.getDocumentType(document.typeId);
    if (type.picto == "") {
      return 'ProjetContrat';
    } else {
      return type.picto;
    }
  }

  // eslint-disable-next-line
  public static getPictoType (document: Document): string {
    return typePicto(PictoTypes.ICON);
  }
}
